import React from 'react';
import { Tabs, Tab } from '@mui/material';
import { Routes, Route, Link, Outlet, useLocation, Navigate } from 'react-router-dom';
import { AdminDataGames } from './AdminDataGames';
import { AdminManageAccounts } from './AdminManageAccounts';
import { AdminProcesses } from './admin-components/AdminProcesses';
import { AdminChangeData } from './AdminChangeData';
import { AdminNotificationRules } from './AdminNotificationRules';

export const AdminPage = () => (
  <Routes>
    <Route path="/" element={<Navigate to="./processes" />} />
    <Route path="/" element={<AdminLayout subpath={useLocation().pathname.replace('/admin-change-data', '')} />}>
      <Route path="processes" element={<AdminProcesses />} />
      <Route path="data-changes" element={<AdminChangeData />} />
      <Route path="data-games" element={<AdminDataGames />} />
      <Route path="manage-accounts" element={<AdminManageAccounts />} />
      <Route path="notification-rules" element={<AdminNotificationRules />} />
    </Route>
  </Routes>
);

const AdminLayout: React.FC<{ subpath: string }> = ({ subpath }) => (
  <div>
    <Tabs value={subpath}>
      <Tab label="Processes admin" value={'/processes'} component={Link} to="processes" />
      <Tab label="Data changes" value={'/data-changes'} component={Link} to="data-changes" />
      <Tab label="Data games" value={'/data-games'} component={Link} to="data-games" />
      <Tab label="Manage Accounts" value={'/manage-accounts'} component={Link} to="manage-accounts" />
      <Tab label="Notification rules" value={'/notification-rules'} component={Link} to="notification-rules" />
    </Tabs>
    <Outlet />
  </div>
);
